module.exports = __webpack_public_path__ + "static/media/insturctor4.001c58b1.png";